import { Controller } from "@hotwired/stimulus";

// Handles phase filter dropdown for project objectives/tasks/todos
// Updates URL parameter and navigates with Turbo on selection change
export default class extends Controller {
  static targets = ["select"];
  static values = { url: String };

  filter() {
    const phase = this.selectTarget.value;
    const url = new URL(this.urlValue, window.location.origin);

    // Preserve existing URL params except phase
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach((value, key) => {
      if (key !== "phase") {
        url.searchParams.set(key, value);
      }
    });

    // Set phase parameter based on selection
    // Use empty string for "All" so Rails detects the explicit choice to clear
    if (phase && phase !== "") {
      url.searchParams.set("phase", phase);
    } else {
      // Set to empty string (not delete) so the server knows "All" was explicitly selected
      url.searchParams.set("phase", "");
    }

    // Navigate with Turbo for smooth page transitions
    Turbo.visit(url.toString());
  }
}
